import React from 'react';
import './RegisterVip.less';
import InputItem from 'antd-mobile/lib/input-item';
import { VerificationCode } from '../../widgets';
// import { _equipmentType } from '../../utils';
import autobind from 'autobind-decorator';
import { toast } from '../../components/notice';
import { baseRequest } from '../../operates';

class RegisterVip extends React.Component<any, any> {
    static defaultProps = {
        prefixCls: 'register-vip'
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            phone: '',
            code: '',
            codeTime: 0,
            documentHeight: 0,
        };
    }

    isClick: boolean = true;
    timer: any = null;
    resizeFlag: boolean = false;

    componentWillMount() {
        let documentHeight: any = document.documentElement.clientHeight || document.getElementsByTagName('html')[0].offsetHeight;
        this.setState({
            documentHeight
        });
    }

    componentDidMount() {
        let codeTime: any = sessionStorage.getItem('code_time1');
        if (codeTime) {
            codeTime = Number(codeTime);
            this._countDown(codeTime);
        }
        let documentHeight: any = document.documentElement.clientHeight || document.getElementsByTagName('html')[0].offsetHeight;
        this.setState({
            documentHeight
        });
    }

    @autobind
    onChangeValue(flag, value) {
        if (flag === 'phone') {
            this.setState({
                phone: value
            });
        } else if (flag === 'code') {
            this.setState({
                code: value.join('')
            });
        }
        this.resizeFlag = false;
    }

    @autobind
    onGetCode() {
        if (this.props.onGetCode) {
            this.props.onGetCode();
        }
    }

    @autobind
    onRegisterBtn() {
        const {phone, code} = this.state;
        if (this.props.onRegisterBtn) {
            this.props.onRegisterBtn(phone, code);
        }
    }

    // 倒计时
    @autobind
    _countDown(time: number): void {
        this.setState({
            isAgain: true
        });
        this.timer = setInterval(() => {
            --time;
            this.setState({
                codeTime: time,
            });
            sessionStorage.setItem('code_time1', String(time));
            if (time <= 0) {
                clearInterval(this.timer);
                sessionStorage.removeItem('code_time1');
            }
        }, 1000);
    }

    // 获取验证码
    @autobind
    obtainCode() {
        const {phone, codeTime} = this.state;
        let that = this;
        if (codeTime > 0) return false;
        if (!this.isClick) return false;
        if (phone.length !== 0) {
            if (phone.length < 11) {
                toast('请填写正确手机号格式');
                return false;
            }
            that.isClick = false;
            baseRequest('user/common/v1/8/send/message', {
                type: '8',
                mobile: phone
            }, (data, errCode, errDesc) => {
                if (errCode === 200) {
                    that.isClick = true;
                    toast('验证码已发送');
                    that._countDown(60);
                    sessionStorage.setItem('code_time1', '60');
                    return false;
                } else {
                    that.isClick = true;
                    toast(errDesc);
                }
            });
        } else {
            toast('请填写注册手机号');
        }
    }

    @autobind
    _showBtn(): void {
        const {codeTime = 0, isAgain} = this.state;
        const {prefixCls} = this.props;
        let btnNode: any = null;
        if (codeTime <= 0) {
            if (isAgain) {
                btnNode = (
                    <div className={`${prefixCls}-codeBtn ${prefixCls}-btnAgain`} onClick={this.obtainCode}>重新获取</div>
                );
            } else {
                btnNode = (
                    <div className={`${prefixCls}-codeBtn`} onClick={this.obtainCode}>获取验证码</div>
                );
            }
        } else {
            btnNode = (
                <div className={`${prefixCls}-codeBtn ${prefixCls}-btnTime`} onClick={this.obtainCode}>
                    {codeTime}秒后重发
                </div>
            );
        }
        return btnNode;
    }

    @autobind
    isRenderHeight() {
        let documentHeight: any = document.documentElement.clientHeight || document.getElementsByTagName("html")[0].offsetHeight;
        this.setState({
            documentHeight
        })
    }

    @autobind
    onBlurHeight(e) {
        if (e.target.className !== 'register-vip-phone' && e.target.className !== 'register-vip-codeBtn' && e.target.className !== 'verification-cover') {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
    }

    render() {
        const {prefixCls, onCloseBox} = this.props;
        const {phone} = this.state;
        return (
            <div className={`${prefixCls}-cover`} onClick={this.onBlurHeight}>
                <div className={`${prefixCls}-container`}>
                    <div className={`${prefixCls}-close`} onClick={onCloseBox}/>
                    <div className={`${prefixCls}-context`}>
                        <p className={`${prefixCls}-title`}>注册VIP</p>
                        <p className={`${prefixCls}-msg`}>绑定手机号完成VIP注册 立即享受优惠</p>
                        <div className={`${prefixCls}-phoneBox clearfix`}>
                            <div className={`${prefixCls}-phone`}>
                                <InputItem
                                    type="number"
                                    value={phone}
                                    maxLength={11}
                                    placeholder={'请输入手机号'}
                                    onChange={(value) => {
                                        this.onChangeValue('phone', value);
                                    }}
                                />
                            </div>
                            {this._showBtn()}
                        </div>
                        <div className={`${prefixCls}-code`}>
                            <VerificationCode
                                onChangeValue={this.onChangeValue}
                            />
                        </div>
                        <div className={`${prefixCls}-btn`} onClick={this.onRegisterBtn}>一键注册购买</div>
                    </div>
                </div>
            </div>
        );
    }

    componentWillUnmount(): void {
        clearInterval(this.timer);
        // document.removeEventListener('onresize', this.onResize);
    }
}

export default RegisterVip;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/registerVip/RegisterVip.tsx